import { render, staticRenderFns } from "./CouponPackage.vue?vue&type=template&id=5d4fd5bb&scoped=true"
import script from "./CouponPackage.vue?vue&type=script&lang=js"
export * from "./CouponPackage.vue?vue&type=script&lang=js"
import style0 from "./CouponPackage.vue?vue&type=style&index=0&id=5d4fd5bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4fd5bb",
  null
  
)

export default component.exports